import { render, staticRenderFns } from "./NftCustomAddModal.vue?vue&type=template&id=704f7a3f&scoped=true&lang=html&"
import script from "./NftCustomAddModal.vue?vue&type=script&lang=js&"
export * from "./NftCustomAddModal.vue?vue&type=script&lang=js&"
import style0 from "./NftCustomAddModal.vue?vue&type=style&index=0&id=704f7a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f7a3f",
  null
  
)

export default component.exports